import React from "react";
import { Link } from "react-router-dom";

export default function Menu() {
  return (
    <>
      <div className="filterdisplaynav text-center p-2 fs-4">
        <h1 className="fs-4">Categories</h1>
      </div>
      <div className="mb-4 menumain">
        <div className="accordion accordion-flush" id="accordionFlushExample">
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingTwo">
              <button
                className="accordion-button collapsed p-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseTwo"
                aria-expanded="false"
                aria-controls="flush-collapseTwo"
              >
                <div>
                  <span>
                    {" "}
                    <b>WOMENS</b>
                  </span>
                </div>
              </button>
            </h2>
            <div
              id="flush-collapseTwo"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingTwo"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body p-0">
                <ul className="list-group">
                  <Link
                    to="/High End Couture"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">High end Couture</li>
                  </Link>
                  <Link to="/sarees" className="text-decoration-none text-dark">
                    <li className="list-group-item">Sarees</li>
                  </Link>
                  <Link
                    to="/lehenga"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Lehengas</li>
                  </Link>
                  <Link
                    to="/dresses"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Dresses</li>
                  </Link>
                  <Link
                    to="/Twinning-outfits,Tie Dye"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Twinning Outfits / Tie Dye</li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingFive">
              <button
                className="accordion-button collapsed p-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseFive"
                aria-expanded="false"
                aria-controls="flush-collapseFive"
              >
                <div>
                  <span>
                    {" "}
                    <b>MENS</b>
                  </span>
                </div>
              </button>
            </h2>
            <div
              id="flush-collapseFive"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingFive"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body p-0">
                <ul className="list-group">
                  <Link
                    to="/shirts"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Shirts</li>
                  </Link>
                  <Link to="/jeans" className="text-decoration-none text-dark">
                    <li className="list-group-item">Jeans</li>
                  </Link>
                  <Link
                    to="/tshirts"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">T-Shirts</li>
                  </Link>
                  <Link
                    to="/sweatshirts"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Hoodies / Sweatshirts</li>
                  </Link>
                  <Link
                    to="/kurtas"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Kurtas</li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingSix">
              <button
                className="accordion-button collapsed p-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseSix"
                aria-expanded="false"
                aria-controls="flush-collapseSix"
              >
                <div>
                  <span>
                    {" "}
                    <b>ACCESSORIES</b>
                  </span>
                </div>
              </button>
            </h2>
            <div
              id="flush-collapseSix"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingSix"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body p-0">
                <ul className="list-group">
                  <Link
                    to="/caps"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Caps</li>
                  </Link>
                  <Link to="/shoes" className="text-decoration-none text-dark">
                    <li className="list-group-item">Shoes</li>
                  </Link>
                  <Link
                    to="/watches"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Watches</li>
                  </Link>
                  <Link
                    to="/belts"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Belts</li>
                  </Link>
                  <Link
                    to="/sunglasses"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Sunglasses</li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>
          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingThree">
              <button
                className="accordion-button collapsed p-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseThree"
                aria-expanded="false"
                aria-controls="flush-collapseThree"
              >
                <div>
                  <span>
                    {" "}
                    <b>KIDS</b>
                  </span>
                </div>
              </button>
            </h2>
            <div
              id="flush-collapseThree"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingThree"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body p-0">
                <ul className="list-group">
                  <Link to="/girl" className="text-decoration-none text-dark">
                    <li className="list-group-item">Girl</li>
                  </Link>
                  <Link to="/boy" className="text-decoration-none text-dark">
                    <li className="list-group-item">Boy</li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>

          <div className="accordion-item">
            <h2 className="accordion-header" id="flush-headingFour">
              <button
                className="accordion-button collapsed p-2"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#flush-collapseFour"
                aria-expanded="false"
                aria-controls="flush-collapseFour"
              >
                <div>
                  <span>
                    {" "}
                    <b>JEWELLERY</b>
                  </span>
                </div>
              </button>
            </h2>
            <div
              id="flush-collapseFour"
              className="accordion-collapse collapse"
              aria-labelledby="flush-headingFour"
              data-bs-parent="#accordionFlushExample"
            >
              <div className="accordion-body p-0">
                <ul className="list-group">
                <Link
                    to="/necklaces"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Necklaces</li>
                  </Link>
                  <Link
                    to="/bangles"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Bangles</li>
                  </Link>
                  <Link
                    to="/earrings"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Earrings</li>
                  </Link>
                  <Link
                    to="/rings"
                    className="text-decoration-none text-dark"
                  >
                    <li className="list-group-item">Rings</li>
                  </Link>
                </ul>
              </div>
            </div>
          </div>

         
        </div>
      </div>
    </>
  );
}
